var _title, _circle, _line, _polyline, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCircleDownload = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ea4426f3-9d79-40b9-bc95-884b2f610380",
    "data-name": "Layer 1",
    viewBox: "0 0 43.99991 44.00006",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon-circle-download")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.99991,
    cy: 21.99997,
    r: 22,
    fill: "#ededed"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.99991,
    y1: 29,
    x2: 26.99991,
    y2: 29,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "17 20 22 25 27 20",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.99991,
    y1: 13,
    x2: 21.99991,
    y2: 24,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircleDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle-download.f84f291f.svg";
export { ForwardRef as ReactComponent };